(function() {
	document.addEventListener("DOMContentLoaded", function() {
		var forSale = document.getElementById("forSaleSign");
		
		if(forSale) {
			var vName = document.getElementById("vehicle-name");
			var vInput= document.getElementById("vehicle-input");
			var maxHeight = 100; // px
			var defFZ = 60; //px

			if(vName) {
				vName.style.fontSize = defFZ + "px";
				
				if(vName.offsetHeight > maxHeight) nameResize(vName, defFZ, maxHeight);

				vInput.value = vName.style.fontSize;

				vName.removeAttribute("style");

				/*document.querySelector("input[name=submitbutton]").addEventListener("click", function(event) {
					//event.preventDefault();

					vName.style.fontSize = defFZ + "px";
					
					if(vName.offsetHeight > maxHeight) nameResize(vName, defFZ, maxHeight);

					vInput.value = vName.style.fontSize;
				});*/

				{

                    /**
                     * Uses canvas.measureText to compute and return the width of the given text of given font in pixels.
                     *
                     * @param {String} text The text to be rendered.
                     * @param {String} font The css font descriptor that text is to be rendered with (e.g. "bold 14px verdana").
                     *
                     * @see https://stackoverflow.com/questions/118241/calculate-text-width-with-javascript/21015393#21015393
                     */
                    function getTextWidth(text, font) {
                        // re-use canvas object for better performance
                        var canvas = getTextWidth.canvas || (getTextWidth.canvas = document.createElement("canvas"));
                        var context = canvas.getContext("2d");
                        context.font = font;
                        var metrics = context.measureText(text);
                        return metrics.width;
                    }

                    let targetBlock = vName;
                    let initialFontSizeInPx = 16;
					// In normal world this could be 'targetBlock.clientWidth', but now it is manually measured width of
					// rendered document's container
                    let initialContainerWidthInPx = 290; // TODO: Change this value when PDF container width is changed
                    let textWidth = getTextWidth(targetBlock.textContent, initialFontSizeInPx + "px monospace");

                    vInput.value = initialContainerWidthInPx * initialFontSizeInPx / textWidth;
				}
			}
		}

		function nameResize(el, size, max) {
			size--;
			el.style.fontSize = size + "px";

			if(el.offsetHeight > max) nameResize(el, size, max);
			else return 0;
		}

	});
})();